import React from "react";
//Material imports
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
var iconVariants = {
  default: InfoOutlined,
  masked: InfoOutlined
};

var DialogueNote = function DialogueNote(_ref) {
  var classes = _ref.classes,
      note = _ref.note,
      position = _ref.position;
  var Icon = iconVariants[note.action];
  Icon = Icon ? Icon : iconVariants["default"];
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: note.reason,
    placement: position,
    classes: {
      popper: classes.toolTipWrapper,
      tooltip: classes.toolTip,
      tooltipPlacementBottom: classes.tooltipPlacementBottom
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    classes: {
      root: classes.iconButton
    },
    "aria-label": note.reason,
    disableTouchRipple: true,
    component: "div"
  }, /*#__PURE__*/React.createElement(Icon, null)));
};

var styles = function styles(theme) {
  return {
    toolTipWrapper: {
      zIndex: 53002
    },
    toolTip: {
      maxWidth: 275
    },
    tooltipPlacementBottom: {
      margin: "4px, 0"
    },
    iconButton: {
      color: theme.palette.contrast.text
    }
  };
};

export default withStyles(styles)(DialogueNote);